import { SidebarAccountInfo } from "@/components/layout/components/sidebar/sidebar-account-info";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { MenuItem } from "react-aria-components";

export const SidebarDropdownAccountInfo = observer(function SidebarDropdownAccountInfo() {
  const { store } = useAppStore();
  const { profilePhotoUrl, profileDisplayName, profileEmailAddress } = store.account.myAccount;

  return (
    <SidebarAccountInfoWrapper isDisabled>
      <SidebarAccountInfo
        profilePhotoUrl={profilePhotoUrl}
        profileDisplayName={profileDisplayName}
        profileEmailAddress={profileEmailAddress}
        plan={store.subscriptions.effectiveDisplayPlanKind}
      />
    </SidebarAccountInfoWrapper>
  );
});

const SidebarAccountInfoWrapper = styled(MenuItem)`
  grid-column: 1 / -1;
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
